import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { CultureService } from 'src/app/modules/core/services/culture.service';
import { DocumentReader } from 'src/app/modules/core/store/models';
import { RecipientAddressCellData } from './recipient-address-model';
import { ChannelSelectionService } from 'src/app/modules/communications/services/channel-selection-service';

@Component({
    selector: 'app-recipient-address-cell',
    templateUrl: './recipient-address-cell.component.html',
    styleUrls: ['./recipient-address-cell.component.scss'],
    standalone: false
})
export class RecipientAddresslCellComponent implements ICellRendererAngularComp {
  data: RecipientAddressCellData;

  constructor(private translateService: TranslateService, private channelSelectionService: ChannelSelectionService) {}

  agInit(params: any): void {
    this.data = this.generateRecipientAddress(this.getValueToDisplay(params));
  }

  refresh(params: ICellRendererParams): boolean {
    this.data = this.generateRecipientAddress(this.getValueToDisplay(params));
    return true;
  }

  private generateRecipientAddress(value: string): RecipientAddressCellData {
    if (!!value) {
      try {
        const ret = JSON.parse(value);
        return ret;
      }
      catch(e) {
      }
    }
    return null;
  }

  getValueToDisplay(params: any) {
    return params.value;
  }
}
